import { Flex, Image, Link, Stack } from '@chakra-ui/react'
import React from 'react'

const CtaRegisterImage: React.FC = () => {
  return (
    <Flex
      bg='white'
      minHeight={{ base: 'unset', lg: '100vh' }}
      flexDirection={['column', 'column', 'column', 'row', 'row']}
    >
      <Stack
        backgroundImage={[
          "url('/assets/images/responsive-onboard-home.svg')",
          "url('/assets/images/responsive-onboard-home.svg')",
          "url('/assets/images/responsive-onboard-home.svg')",
          "url('/assets/images/onboard-home.svg')",
          "url('/assets/images/onboard-home.svg')",
        ]}
        backgroundSize={{ base: '150%, auto, cover', sm: '125%, auto, cover', md: '100%, auto, cover', lg: 'cover' }}
        backgroundRepeat='no-repeat'
        backgroundPosition={{ base: 'top', lg: 'unset' }}
        flexDirection='column'
        alignItems='flex-start'
        flex='1'
        minHeight={{ base: '400px', lg: 'auto' }}
      >
        <Link href='https://new.education-journey.com/'>
          <Image margin='30px 0px 0px 30px' width='200px' src='/assets/images/ej-white-logo.svg' />
        </Link>
      </Stack>
    </Flex>
  )
}

export default CtaRegisterImage
